import FormField from "components/v2/FormField";

// Keep the older field API on the same accessible form foundation.
export default function TextField({ info, ...props }) {
  return <FormField {...props} helperText={props.helperText || info} />;
}
